class MiniCart extends HTMLElement {
  constructor() {
    super();

    //add event listeners
    this.addListeners();
    this.renderUpsells();

    //event listeners
    document.addEventListener(
      "mini-cart-open",
      this.handleMiniCartTrigger.bind(this)
    );

    document.addEventListener(
      "mini-cart-refresh",
      this.handleMiniCartRefresh.bind(this)
    );

  }

  handleMiniCartTrigger(event) {
    event.stopPropagation();
    this.renderCart();
    this.renderUpsells();

    document
      .getElementById("drawer-mini-cart")
      .dispatchEvent(new Event("drawer-toggle"));
  }

  handleMiniCartRefresh(event) {
    event.stopPropagation();
    this.renderCart();
    this.renderUpsells();
  }

  //quantity input change
  handleInputChange(input, key) {
    this.classList.add("loading");
    let lineKey = key;
    let quantity = 0;

    if (input && input.getAttribute("data-key")) {
      lineKey = input.getAttribute("data-key");
    }

    if (input && input.value) {
      quantity = parseInt(input.value);
    }

    if (lineKey && quantity >= 0) {
      const body = JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: "stmt-mini-cart-items",
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          let sectionHtml = JSON.parse(text).sections["stmt-mini-cart-items"];
          this.renderCart(sectionHtml);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      this.classList.remove("loading");
      console.error("No line item details");
    }
  }

  renderCart(html) {
    this.classList.add("loading");

    if (html) {
      //insert cart items
      this.querySelector(".js-mini-cart-items").innerHTML = html;

      this.postRenderFunctions();
    } else {
      fetch("/?section_id=stmt-mini-cart-items")
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          //insert cart items
          this.querySelector(".js-mini-cart-items").innerHTML = response;

          this.postRenderFunctions();
        });
    }
  }

  postRenderFunctions() {
    //add event listeners
    this.addListeners();

    //render upsells
    this.renderUpsells();

    //update cart count
    this.updateCount();

    //update total
    this.updateTotal();

    //update free delivery
    this.updateFreeDel();

    //remove loading icon
    this.classList.remove("loading");
  }

  addListeners() {
    //get form elements and add event listeners
    this.miniCartForm = this.querySelector("form");
    this.quantityInputs = this.miniCartForm.querySelectorAll(
      ".js-mini-cart-quantity"
    );
    this.removeButtons = this.miniCartForm.querySelectorAll(
      "mini-cart-remove-button"
    );
    this.quantityInputs.forEach((input) =>
      input.addEventListener("change", this.handleInputChange.bind(this, input))
    );
    this.removeButtons.forEach((input) =>
      input.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleInputChange(null, input.getAttribute("data-key"));
      })
    );
  }

  updateCount() {
    //updates cart counter
    let itemCount = document.getElementById("cart-item-count-hidden");
    let countElements = document.querySelectorAll(".js-cart-count");
    if (itemCount && countElements) {
      countElements.forEach((el) => {
        el.innerHTML = itemCount.innerHTML;
      });
    }
  }

  updateTotal() {
    //updates cart total
    let totalElements = document.querySelectorAll(".js-mini-cart-total");
    let cartTotal = document.getElementById("cart-total-hidden");

    if (totalElements && cartTotal) {
      totalElements.forEach((el) => {
        el.innerHTML = cartTotal.innerHTML;
      });
    }
  }

  renderUpsells() {
    fetch("/?section_id=stmt-cart-upsells")
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        let cartUpsells = this.querySelector(".js-mini-cart-upsells");

        if (cartUpsells) {
          cartUpsells.innerHTML = response;
        }
      });
  }

  updateFreeDel() {
    let freeDel = document.querySelectorAll(".js-cart-delivery");
    let remainingTotal = document.getElementById("free-del-remaining");

    if (freeDel && remainingTotal) {
      freeDel.forEach((el) => {
        el.innerHTML = remainingTotal.innerHTML;
      });
    }
  }
}

customElements.define("mini-cart", MiniCart);
